mutation PurchaseOrderCreate($input: PurchaseOrderCreateInput!) {
  purchaseOrderCreate(input: $input) {
    purchaseOrder {
      __typename
      id
      _accountingExportCycleId
      _accountingExportDate
      userExport {
        name
      }
      _urgencyLevel
      _isUpdatable
      sortSupplierName
      _isDeletable
      _isDistributionUpdateAllowed
      _purchaseOrderDeliveryId
      purchaseOrderType {
        purchaseOrderType
      }
      _appliedTotals {
        usedAmount
        remainingAmount
        appliedAmount
        retiredAmount
        overageAmount
      }
      purchaseOrderNumber
      purchaseOrderDate
      supplier {
        id
        _fullName
        _isUpdatable
      }
      description
      department {
        name
        id
      }
      businessUnit {
        id
        name
        companyAddress {
          addressAlias
          addressLine1
          addressLine2
          cityName
          postalCode
        }
      }
      currency {
        id
        isoCode
        currencySymbol
      }
      controlTotalAmount
      _statusTypeId
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _rowTimestamp
      _referenceItemTypes
      _accountingStampTransactionReference
      _createdByUserName
      _createdDate
      _baseCurrencyAmount
      _spotCurrencyAmount
      _isStagedApprovalRequest
      _pendingApprovers
      _isAccountingEntryStampedComplete
      _isAccountingEntry
      documentFileId
      purchaseOrderTypeId
      currencyId
      departmentId
      businessUnitId
      entityDocumentId
      deliveryAddressId
      deliveryAddressAlias
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryCityName
      deliveryCountryId
      deliveryStateRegionId
      deliveryPostalCode
      deliveryTelephoneNumber
      deliveryEmailAddress
      scheduledDeliveryDate
      deliveryNotes
      isDeliveryTracked
      isDraft
      _isInvoiceScheduleViewable
      _isInvoiceScheduleUpdatable
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
      _isStampAllowed
      _isUnstampAllowed
      _isRevisable
      _isTransactionCancelled
      _isApprovalRevocable
      _isPromoteAddressAllowed
      _isEnvironmentalsExist
      secureRowLevel {
        id
        name
        description
        securityLevel
      }
    }
  }
}
